<!--
    描述：支付结算 --- 收款账号设置
    时间：2020-11-12
    Created by ws
-->
<template>
    <div class="payment-main primary-dialog">
        <div class="title">账户信息</div>
        <div class="content">
            <!-- 有账户信息 -->
            <template v-if="hasInfo">
                <baseForm
                    :baseInfo="baseInfo"
                    :memberId="memberId"
                    :bizUserid="bizUserid"
                    :checkState="checkState"
                    mode="view"
                    :disabled="true"
                ></baseForm>
                <el-button
                    icon="el-icon-edit"
                    size="small"
                    class="btn-blue"
                    v-if="showEdit"
                    @click="openDialog('edit')"
                    >修改</el-button
                >
            </template>
            <!-- 没有账户信息 显示添加按钮 -->
            <template v-else>
                <div class="add-btn-box">
                    <img class="no-msg" src="@/assets/images/no-msg.png" alt="" />
                    <el-button
                        class="add-btn"
                        icon="el-icon-plus"
                        @click="openDialog('add')"
                        >添加收款账户</el-button
                    >
                </div>
            </template>
        </div>

        <!-- 新增 、 编辑弹窗 -->
        <el-dialog
            :visible.sync="infoDialog.visible"
            :title="infoDialog.title"
            :width="infoDialog.width"
            @closed="handleClosed"
            :close-on-click-modal="false"
        >
            <!-- 基本信息 -->
            <baseForm
                v-if="infoDialog.visible && infoDialog.type === 'add'"
                v-loading="infoDialog.btnLoading"
                ref="baseForm"
                :baseInfo="baseInfo"
                :mode="infoDialog.mode"
                :memberId="memberId"
                :checkState="checkState"
                :bizUserid="bizUserid"
                @setAccountId="setAccountId"
                @setFileList="setFileList"
                @on-error="onError"
                :disabled="isDisabled"
            ></baseForm>

            <!-- 手机号验证 -->
            <el-form
                :model="phoneForm"
                label-width="140px"
                :rules="phoneRule"
                ref="phoneForm"
                :show-message="false"
                v-loading="infoDialog.btnLoading"
                v-if="infoDialog.visible && infoDialog.type === 'tel'"
            >
                <el-row>
                    <el-col :span="16">
                        <el-form-item label="短信接收手机号：" prop="tiedPhone">
                            <el-input
                                v-model="phoneForm.tiedPhone"
                                class="mr10"
                                maxlength="11"
                                placeholder="请输入短信接收手机号"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7" :offset="1">
                        <el-button
                            type="primary"
                            class="btn-blue w100"
                            @click="getPhonecCode"
                            :loading="infoDialog.codeLoading"
                            :disabled="infoDialog.codeDisabled"
                            >{{ infoDialog.codeText }}</el-button
                        >
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="手机验证码：" prop="scode">
                            <el-input
                                v-model="phoneForm.scode"
                                placeholder="请输入手机验证码"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="16">
                        <p class="agreement" @click="openAgreement">
                            点击签署《通联支付网络交易资金管理服务三方协议》
                        </p>
                    </el-col>
                    <el-col :span="8" class="align-right">
                        <el-tag
                            :type="agreementState === '已签署' ? 'success' : 'info'"
                            size="small"
                            >{{ agreementState }}</el-tag
                        >
                    </el-col>
                </el-row>
            </el-form>

            <div slot="footer" class="text-center">
                <!-- 第一步 -->
                <template v-if="infoDialog.type === 'add'">
                    <el-button size="small" class="btn" @click="infoDialog.visible = false"
                        >取消</el-button
                    >
                    <el-button
                        type="primary"
                        size="small"
                        class="btn btn-blue"
                        @click="doNext"
                        :loading="infoDialog.btnLoading"
                        >下一步</el-button
                    >
                </template>

                <!-- 第二步 手机号验证 -->
                <template v-if="infoDialog.type === 'tel'">
                    <el-button
                        size="small"
                        class="btn"
                        :loading="infoDialog.btnLoading"
                        @click="infoDialog.visible = false"
                        >取消</el-button
                    >
                    <el-button
                        type="primary"
                        size="small"
                        class="btn btn-blue"
                        @click="doSubmit"
                        :loading="infoDialog.btnLoading"
                        >提交</el-button
                    >
                </template>
                <!-- <el-button type="primary"
						   size="small"
						   class="btn-blue"
						   :disabled="sumbit">提交</el-button> -->
            </div>
        </el-dialog>

        <el-dialog
            :visible.sync="visibleState"
            title="审核中"
            width="80%"
            center
            :close-on-click-modal="false"
        >
            <!-- waiting 状态 -->
            <div v-if="visibleState" class="waiting-box">
                正在审核中，请耐心等候, {{ timerNum }}s...
            </div>
        </el-dialog>

        <!-- 查看模板 -->
        <el-dialog
            :visible.sync="visibleImg"
            title="图片预览"
            width="80%"
            center
            :close-on-click-modal="false"
        >
            <div class="tempalte-img">
                <img src="@/assets/images/template.jpg" alt="" />
            </div>
        </el-dialog>

        <!-- 查看模板 -->
        <el-dialog
            :visible.sync="visibleUrl"
            title="通联支付网络交易资金管理服务三方协议"
            :close-on-click-modal="false"
            width="80%"
            class="addPay"
            fullscreen
            @closed="closeAgressMent"
            center
        >
            <div class="h100">
                <iframe
                    :src="openUrl"
                    frameborder="0"
                    height="100%"
                    width="100%"
                ></iframe>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import baseForm from "./baseForm.vue";

import {
    sendVerificationCode,
    selectDeptByUserId,
    accountVerify,
    signContract,
    getApplyRecordResult,
    saveApplyRecord,
    bindPhone,
} from "api/modules/paymentSettlement";

export default {
    components: {
        baseForm,
    },
    data() {
        return {
            hasInfo: false,
            isDisabled: false,
            checkState: 0, // 审核状态
            infoDialog: {
                visible: false,
                title: "添加收款账户",
                type: "add",
                mode: "add",
                width: "1000px",
                btnLoading: false,
                checkState: false,
                codeDisabled: false, // 验证码按钮
                codeLoading: false,
                codeText: "点击获取验证码", // 验证码按钮显示文字
            },
            baseInfo: {
                sname: "",
                creditCode: "",
                legalar: "",
                idCard: "",
                legalPhone: "",
            },
            visibleImg: false,
            visibleUrl: false,
            visibleState: false,
            sumNum: 0,
            openUrl: "", // 通联协议地址
            bizUserid: "",
            memberId: "", // 会员ID
            accountId: "", // 账户ID （数据库）
            fileList: {},
            // 手机号弹窗
            timeChange: null,
            phoneForm: {
                tiedPhone: "",
                scode: "",
            },
            phoneRule: {
                tiedPhone: [
                    {
                        required: true,
                        message: "手机号不能为空",
                        trigger: "blur",
                    },
                    {
                        pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
                        message: "手机号码格式有误！",
                        trigger: "blur",
                    },
                ],
                scode: [
                    {
                        required: true,
                        message: "验证码不能为空",
                        trigger: "blur",
                    },
                ],
            },
            agreementState: "未签署",
            isEdit: true,
            showEdit: true,
            timer: null,
            timerNum: 35,
            numInterval: null,
            agreeTimer: null,
        };
    },
    created() {
        this.selectDeptByUserId();
    },
    methods: {
        // 获取企业信息
        selectDeptByUserId() {
            selectDeptByUserId({}).then((d) => {
                if (d.operationCode == 1) {
                    // 设置会员 或者 回显
                    let params = {
                        id: d.data.id, // 企业ID
                        type: 1, // 1 能公社运营  2 能工社
                        memberType: 1, // 1 平台会员  2企业会员 3 个人会员
                        sname: d.data.sname,
                        cardNo: d.data.creditCode,
                    };
                    this.echoAccount(params);

                    this.baseInfo = d.data;
                }
            });
        },

        // 设置会员 或者 回显
        echoAccount(params) {
            accountVerify(params).then((res) => {
                // console.log(res)
                if (res.data.list && res.data.list.length > 0) {
                    this.hasInfo = true;
                    this.baseInfo = res.data;
                    this.accountId = res.data.id;

                    let state = res.data.list.find((x) => x.type === 0).state;
                    this.checkState = state;

                    let agree = res.data.list.find((x) => x.type === 3);
                    if (agree && agree.state === 1) {
                        this.isEdit = false;
                    }

                    // 查询状态
                    this.getAllRecords();
                }
                this.bizUserid = res.data.bizUserid;
                this.memberId = res.data.id;
            });
        },

        // 添加收款账号
        openDialog(type) {
            this.infoDialog.mode = type;
            this.isDisabled = type !== "add";
            this.infoDialog.title = type === "add" ? "添加收款账户" : "编辑收款账户";
            this.infoDialog.visible = true;
            this.infoDialog.width = "1000px";
        },

        // 设置账户ID
        setAccountId(id) {
            this.accountId = id;
        },

        // 设置文件对象
        setFileList(obj) {
            this.fileList = obj;
        },

        // 查询所有业务状态
        getAllRecords() {
            if (this.accountId === "") {
                return;
            }

            let that = this;
            let fun1 = function () {
                return new Promise((resolve, reject) => {
                    getApplyRecordResult({
                        accountId: that.accountId,
                        type: 0,
                    })
                        .then((res) => {
                            that.checkState = res.data.state || 0;
                        })
                        .catch((err) => {});
                });
            };
            let fun2 = function () {
                return new Promise((resolve, reject) => {
                    getApplyRecordResult({
                        accountId: that.accountId,
                        type: 1,
                    })
                        .then((res) => {})
                        .catch((err) => {});
                });
            };
            let fun3 = function () {
                return new Promise((resolve, reject) => {
                    getApplyRecordResult({
                        accountId: that.accountId,
                        type: 2,
                    })
                        .then((res) => {})
                        .catch((err) => {});
                });
            };
            let fun4 = function () {
                return new Promise((resolve, reject) => {
                    getApplyRecordResult({
                        accountId: that.accountId,
                        type: 3,
                    })
                        .then((res) => {})
                        .catch((err) => {});
                });
            };

            if (this.baseInfo.list && this.baseInfo.list.length > 0) {
                let a = this.baseInfo.list.find((x) => x.type === 0);
                a && a.state !== 1 ? fun1() : "";

                let b = this.baseInfo.list.find((x) => x.type === 1);
                b && b.state !== 1 ? fun2() : "";

                let c = this.baseInfo.list.find((x) => x.type === 2);
                c && c.state !== 1 ? fun3() : "";

                let d = this.baseInfo.list.find((x) => x.type === 3);
                d && d.state !== 1 ? fun4() : "";

                // 是否显示修改按钮
                if (
                    a &&
                    a.state === 1 &&
                    b &&
                    b.state === 1 &&
                    c &&
                    c.state === 1 &&
                    d &&
                    d.state === 1
                ) {
                    this.showEdit = false;
                }
            }
        },

        // 点击下一步
        doNext() {
            this.infoDialog.btnLoading = true;
            let that = this;
            if (this.infoDialog.mode === "add") {
                this.doSave(false);
            } else {
                // 编辑状况下
                switch (this.checkState) {
                    case 0: // --- 待审核 --- 主动调接口
                        this.$message.warning("暂未审核通过，请耐心等待审核结果！");
                        break;
                    case 1: // --- 审核通过 --- 进入下一步
                        setTimeout(() => {
                            this.infoDialog.btnLoading = false;
                        }, 1000);
                        this.visibleState = false;

                        let params = {
                            file1: this.$refs.baseForm.$refs.codeUpload.addList[0],
                            file2: this.$refs.baseForm.$refs.idCardZ.addList[0],
                            file3: this.$refs.baseForm.$refs.idCardF.addList[0],
                        };

                        let status = this.$refs.baseForm.doSubmit(false, true);
                        if (!status) {
                            return;
                        } else {
                            this.$refs.baseForm.uploadPictures(params);
                            // 查协议状态
                            this.getAgreeState();

                            this.infoDialog.visible = true;
                            this.infoDialog.type = "tel";
                            this.infoDialog.width = "630px";
                            this.infoDialog.title = "手机号验证";
                        }
                        // that.$message.success("基本信息保存成功！");

                        break;
                    case 2: // --- 审核失败 --- 重新保存
                        this.doSave(true);
                }
            }
        },

        // doSave
        doSave(isEdit) {
            let that = this;

            // 保存
            let status = that.$refs.baseForm.doSubmit(isEdit);
            if (!status) {
                setTimeout(() => {
                    that.infoDialog.btnLoading = false;
                    that.numInterval ? clearInterval(that.numInterval) : "";
                }, 1000);
                return;
            } else {
                that.timerNum = 35;
                that.visibleState = true;

                // 倒计时
                that.numInterval = setInterval(() => {
                    that.timerNum--;

                    if (that.timerNum === 0) {
                        that.handleClosed();
                        clearInterval(that.numInterval);
                    }
                }, 1000);
                that.getIntervalRecords();
            }
        },

        // 新增频繁调用
        getIntervalRecords() {
            let that = this;
            this.timer = setInterval(() => {
                // 如果倒计时已结束， 回到首页
                if (that.timerNum === 0) {
                    clearInterval(that.timer);
                    that.handleClosed();
                    that.$message.warning("网络波动，请稍候查询审核结果！");
                }

                if (that.accountId !== "") {
                    // 获取审核状态
                    getApplyRecordResult({
                        accountId: that.accountId,
                        type: 0,
                    })
                        .then((res) => {
                            that.checkState = res.data.state || 0;
                            if (res.data.state === 1) {
                                // 审核成功 --- 清除定时器
                                clearInterval(that.timer);
                                clearInterval(that.numInterval);
                                that.timer = null;
                                that.visibleState = false;
                                that.infoDialog.btnLoading = false;

                                that.$refs.baseForm.uploadPictures(that.fileList);
                                that.$message.success("基本信息保存成功！");
                                // 查协议状态
                                this.getAgreeState();

                                that.infoDialog.visible = true;
                                that.infoDialog.type = "tel";
                                that.infoDialog.width = "630px";
                                that.infoDialog.title = "手机号验证";
                            } else if (res.data.state === 2) {
                                // 审核失败 --- 接口报错，重新编辑
                                clearInterval(that.timer);
                                clearInterval(that.numInterval);
                                that.timer = null;
                                that.visibleState = false;
                                that.infoDialog.btnLoading = false;
                                that.$message.warning(
                                    "审核失败，请重新编辑确认后保存数据!"
                                );
                            } else {
                                // 未审核好 -- 继续请求
                            }
                        })
                        .catch((err) => {});
                }
            }, 1000);
        },

        // 点击获取验证码
        getPhonecCode() {
            this.infoDialog.codeDisabled = true;
            this.infoDialog.codeLoading = true;

            if (this.phoneForm.tiedPhone === "") {
                this.$message.warning("请填写手机号!");

                setTimeout(() => {
                    this.infoDialog.codeDisabled = false;
                    this.infoDialog.codeLoading = false;
                }, 1500);
                return;
            }

            sendVerificationCode({
                tiedPhone: this.phoneForm.tiedPhone,
                bizUserId: this.bizUserid,
            }).then((res) => {
                this.infoDialog.codeLoading = false;
                if (res.operationCode == 1) {
                    this.$message.success("验证码获取成功, 请尽快使用!");
                    let that = this;
                    let downCount = 60;

                    this.timeChange = setInterval(() => {
                        downCount -= 1;
                        that.infoDialog.codeText = `${downCount}s 后再次获取`;

                        if (downCount == 0) {
                            clearInterval(that.timeChange);
                            that.infoDialog.codeText = "点击获取授权码";
                            that.infoDialog.codeDisabled = false;
                        }
                    }, 1000);
                }
            });
        },

        // 新增、编辑弹窗关闭事件
        handleClosed() {
            this.visibleState = false;
            this.infoDialog.visible = false;
            this.infoDialog.type = "add";
            this.infoDialog.mode = "add";
            this.infoDialog.width = "80%";

            // 刷新页面
            this.selectDeptByUserId();

            if (this.numInterval) {
                clearInterval(this.numInterval);
            }

            if (this.timer) {
                clearInterval(this.timer);
            }

            if (this.agreeTimer) {
                clearInterval(this.agreeTimer);
            }

            // 查询状态
            this.getAllRecords();
        },

        // 新增接口报错处理
        onError(type) {
            if (type === 1) {
                // 设置企业信息 -- 通联接口报错
                if (this.numInterval) {
                    clearInterval(this.numInterval);
                }

                if (this.timer) {
                    clearInterval(this.timer);
                }

                this.visibleState = false;
                this.infoDialog.btnLoading = false;
                this.$message.warning("审核失败，请重新编辑确认后保存数据!");
            }
        },

        // 打开协议弹窗
        openAgreement() {
            signContract({
                bizUserId: this.bizUserid,
            }).then((res) => {
                if (res.code === 0) {
                    this.openUrl = res.data;
                    this.visibleUrl = true;
                }
            });
        },

        // 查询协议状态
        getAgreeState(isFirst) {
            let that = this;
            // 往数据库塞记录
            getApplyRecordResult({
                accountId: this.accountId,
                type: 3,
            })
                .then((res) => {
                    // 如果没有记录 则塞一条
                    if (res.operationCode === 2) {
                        saveApplyRecord({
                            accountId: this.accountId,
                            type: 3,
                        })
                            .then((res) => {})
                            .catch((err) => {});
                    } else {
                        if (res.data.state === 1) {
                            that.agreementState = "已签署";
                        } else {
                            that.agreementState = "未签署";
                        }
                    }
                })
                .catch((err) => {});
        },

        // 协议弹窗关闭事件
        closeAgressMent() {
            let that = this;
            that.agreeTimer = setInterval(() => {
                if (that.agreementState === "已签署") {
                    clearInterval(that.agreeTimer);
                }

                getApplyRecordResult({
                    accountId: that.accountId,
                    type: 3,
                })
                    .then((res) => {
                        if (res.data.state === 1) {
                            that.agreementState = "已签署";
                        } else {
                            that.agreementState = "未签署";
                        }
                    })
                    .catch((err) => {
                        clearInterval(that.agreeTimer);
                    });
            }, 1000);
        },

        // 最终提交
        doSubmit() {
            this.infoDialog.btnLoading = true;
            // 绑定手机号
            this.$refs.phoneForm.validate((valid) => {
                if (valid) {
                    if (this.agreementState !== "已签署") {
                        this.$message.warning("请先打开弹窗签署协议！");
                        setTimeout(() => {
                            this.infoDialog.btnLoading = false;
                        }, 1000);
                        return;
                    }

                    // 最终确认
                    bindPhone({
                        bizUserId: this.bizUserid,
                        tiedPhone: this.phoneForm.tiedPhone,
                        verificationCode: this.phoneForm.scode,
                    })
                        .then((res) => {
                            this.infoDialog.btnLoading = false;
                            if (res.code === 0) {
                                setTimeout(() => {
                                    this.$message.success("提交成功！");
                                    this.handleClosed();
                                }, 1000);
                            }
                        })
                        .catch((err) => {
                            this.infoDialog.btnLoading = false;
                        });
                } else {
                    this.$message("请完善手机号和验证码！");
                    setTimeout(() => {
                        this.infoDialog.btnLoading = false;
                    }, 1000);
                }
            });
        },

        // 点击取消
        doCancel() {
            this.infoDialog.visible = false;
        },
    },
};
</script>

<style scoped lang="less">
.payment-main {
    height: 100%;
    padding: 20px;

    .title {
        height: 40px;
        line-height: 40px;
        padding-left: 15px;
        background-color: #dcdfe6;
        color: #202020;
        font-size: 14px;
        border-radius: 5px 5px 0px 0px;
    }

    .content {
        height: calc(~"100% - 40px");
        padding-top: 15px;
        overflow: hidden;
        overflow-y: auto;
    }

    .add-btn-box {
        width: 380px;
        margin: 100px auto;
        text-align: center;

        .no-msg {
            width: 100%;
        }

        .add-btn {
            margin-top: 10px;
            width: 60%;
            background-color: #2671cc;
            color: #fff;
        }
    }

    .agreement {
        font-size: 13px;
        color: #5489d0;
        line-height: 24px;
        border-bottom: 1px solid #5489d0;
        text-align: center;
        cursor: pointer;
    }

    .align-right {
        text-align: right;
    }
}
</style>

<style scoped>
.waiting-box {
    text-align: center;
    line-height: 200px;
    font-size: 20px;
}
>>> .el-dialog__body {
    max-height: unset;
    height: calc(100% - 45px);
}
</style>
